import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import './index.scss';

const SquareQty = ({displayedQty, className = '', onSelectedQty, highlight}) => (
  <li
    className={cs(className, 'SquareQty', {
      'SquareQty--highlight': highlight,
    })}
    onClick={onSelectedQty}
  >
    {displayedQty}
  </li>
);

SquareQty.propTypes = {
  displayedQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Css class name */
  className: PropTypes.string,

  /** Method called when qty is clicked */
  onSelectedQty: PropTypes.func.isRequired,

  /** If square is highlighted */
  highlight: PropTypes.bool,
};

export default SquareQty;
